export default function (props) {

    let numberOfPages = Math.trunc(props.total / props.pageSize);
    if(props.total % props.pageSize !== 0)
    {
        numberOfPages++;
    }
    let paginationLinks = [];
    if(props.currentPage > 1)
    {
        paginationLinks.push(
            <li key={'previous'} className="page-item">
                <a className="page-link" href="#" onClick={e=>{
                    e.preventDefault();
                    props.setPage(props.currentPage - 1);
                }}>
                    Previous
                </a>
            </li>
        )
    }
    if(numberOfPages < 10) {
        if(numberOfPages > 1)
        {
            for(let i=0; i<numberOfPages; i++)
            {
                const page = i+1;
                paginationLinks.push(
                    <li key={page} className={props.currentPage === page ? 'page-item active' : 'page-item'}>
                        <a className="page-link" href="#" onClick={e=>{
                            e.preventDefault();
                            props.setPage(page)
                        }}>{page}</a>
                    </li>
                );
            }
        }
    } else {

        paginationLinks.push(
            <li key={1} className={props.currentPage === 1 ? 'page-item active' : 'page-item'}>
                <a className={'page-link'} href="#" onClick={e=>{
                    e.preventDefault();
                    props.setPage(1);
                }}>
                    1
                </a>
            </li>
        )

        if(props.currentPage !== 1 && props.currentPage !== numberOfPages)
        {
            paginationLinks.push(
                <li key={'current'} className="page-item active">
                    <a className="page-link" href="#" onClick={e=>{
                        e.preventDefault();
                    }}>
                        {props.currentPage}
                    </a>
                </li>
            )
        }

        if(numberOfPages !== 1)
        {
            paginationLinks.push(
                <li key={numberOfPages} className={props.currentPage === numberOfPages ? 'page-item active' : 'page-item'}>
                    <a className={'page-link'} href="#" onClick={e=>{
                        e.preventDefault();
                        props.setPage(numberOfPages);
                    }}>
                        {numberOfPages}
                    </a>
                </li>
            )
        }
    }

    if(props.currentPage < numberOfPages)
    {
        paginationLinks.push(
            <li key={'next'} className="page-item">
                <a className="page-link" href="#" onClick={e=>{
                    e.preventDefault();
                    props.setPage(props.currentPage + 1);
                }}>
                    Next
                </a>
            </li>
        )
    }
    return (
        <div className={props.className}>
            <ul className="pagination">
                {paginationLinks}
            </ul>
        </div>
    )
}
